import React, { useState, useEffect } from 'react';
import { getAllPartners, API_BASE_URL } from '../services/api';

const Partenaires = () => {
  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPartners = async () => {
      try {
        const res = await getAllPartners();
        setPartners(res.data);
      } catch (err) {
        console.error("Erreur lors de la récupération des partenaires:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchPartners();
  }, []);

  // Nettoyage et formatage dynamique de l'image
  const getLogoUrl = (url) => {
    if (!url) return null;
    
    // Si l'URL stockée en BDD contient localhost, on extrait la partie relative
    const cleanUrl = url.replace('http://localhost:5000', '');
    
    // Si c'est un lien Web complet (ex: https://site.com/logo.png)
    if (cleanUrl.startsWith('http')) return cleanUrl;
    
    // Si c'est un chemin relatif (/uploads/logos/...)
    return `${API_BASE_URL}${cleanUrl.startsWith('/') ? '' : '/'}${cleanUrl}`;
  };

  if (loading) return null;

  return (
    <section className="py-5 bg-white border-top">
      <div className="container">
        <div className="d-flex align-items-center mb-4 pb-2 border-bottom">
          <h4 className="fw-black text-uppercase m-0">
            <i className="bi bi-hand-thumbs-up-fill text-primary me-2"></i>Nos Partenaires
          </h4>
        </div>

        <div className="row g-4">
          {partners.map((p) => {
            const logoSrc = getLogoUrl(p.logo_url);

            return (
              <div key={p.id} className="col-md-6">
                <div 
                  className="card h-100 border-0 shadow-sm rounded-4 p-4 partenaire-card"
                  onClick={() => p.site_url && window.open(p.site_url, '_blank')}
                  style={{ cursor: p.site_url ? 'pointer' : 'default' }}
                >
                  <div className="d-flex align-items-start gap-3">
                    <div className="partner-logo-box bg-light rounded-3 overflow-hidden border">
                      {logoSrc ? (
                        <img 
                          src={logoSrc} 
                          alt={p.nom}
                          className="partner-img"
                        />
                      ) : (
                        <div className="d-flex align-items-center justify-content-center h-100 text-primary">
                          <i className="bi bi-building fs-3"></i>
                        </div>
                      )}
                    </div>

                    <div className="flex-grow-1">
                      <span className="badge bg-primary bg-opacity-10 text-primary text-uppercase mb-2 fw-bold border border-primary border-opacity-10" style={{fontSize: '10px'}}>
                        {p.categorie || "Partenaire"}
                      </span>
                      <h5 className="fw-black text-uppercase mb-2">{p.nom}</h5>
                      <p className="text-muted small mb-0 lh-base">
                        {p.presentation}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <style>{`
        .partner-logo-box {
          min-width: 80px;
          width: 80px;
          height: 80px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .partner-img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          padding: 5px;
        }
        .partenaire-card {
          transition: all 0.3s ease;
          border: 1px solid transparent !important;
        }
        .partenaire-card:hover {
          transform: translateY(-5px);
          border-color: rgba(0, 74, 153, 0.1) !important;
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05) !important;
        }
      `}</style>
    </section>
  );
};

export default Partenaires;